import React from "react";
import { useNavigate } from "react-router-dom";
import "../styles/crm.css";
import Nav from "../components/Nav";
import { useMediaQuery } from 'react-responsive';
import { useRef } from "react";
import { useEffect } from "react";
import Footer from "../components/Footer";

const crmFeatures = [
  {
    title: "Lead Management",
    text: "Capture, organize, and manage leads in one place so your team never misses an opportunity.",
  },
  {
    title: "WhatsApp Integration",
    text: "Connect customer conversations directly to your workflow for faster responses and smoother follow-ups.",
  },
  {
    title: "Sales Tracking",
    text: "Monitor customer journeys, deal stages, and conversions with a clear and simple process.",
  },
  {
    title: "Team Collaboration",
    text: "Assign leads, track updates, and keep your sales and support teams aligned at every stage.",
  },
  {
    title: "Automation",
    text: "Reduce manual work with automated follow-ups, reminders, and customer management flows.",
  },
  {
    title: "Reports & Insights",
    text: "Understand performance with useful reports that help you make smarter business decisions.",
  },
];

const crmSteps = [
  "Capture leads from WhatsApp, forms, and direct inquiries",
  "Assign leads to your team and track progress",
  "Follow up with customers faster and more consistently",
  "Measure results with clear reports and insights",
];



const Crm = () => {
  const navigate = useNavigate();

  const handleContact = () => {
    navigate("/get-in-touch");
  };

     const servicesRef = useRef(null);
        
     useEffect (() => {
      const revealElements = servicesRef.current.querySelectorAll("[data-reveal]");
       const scrollReveal = () => {
          for (let i = 0; i < revealElements.length; i++) {
           const elementIsInScreen =
          revealElements[i].getBoundingClientRect().top < window.innerHeight / 1.15;
        
        if (elementIsInScreen) {
         revealElements[i].classList.add("revealed");
         } else {
            revealElements[i].classList.remove("revealed");
             }
          }
         };
        
         window.addEventListener("scroll", scrollReveal);
            scrollReveal(); // Initial check
        
            return () => {
              window.removeEventListener("scroll", scrollReveal);
            };
          }, []);

  return (
    <>
   <div className='home__wrapper' ref={servicesRef}>
  <Nav/>
   
    <section className="crm-page">
      <div className="crm-hero">
        <div className="crm-container crm-hero-grid">
          <div className="crm-hero-content">
             <h1>Manage leads, customers, and follow-ups in one smart system.</h1>
            <p>
              Our CRM solutions help businesses organize customer conversations,
              improve response times, track sales activity, and build stronger
              customer relationships with less manual work.
            </p>

            <div className="crm-hero-actions">
          
              <a href="#crm-features" className="crm-secondary-btn">
                Explore Features
              </a>
            </div>
          </div>

          <div className="crm-hero-card">
            <div className="crm-card-top" data-reveal="left">
              <span className="crm-dot"></span>
              <span className="crm-dot"></span>
              <span className="crm-dot"></span>
            </div>

            <div className="crm-dashboard-preview">
              <div className="crm-preview-box" data-reveal>
                <h4 data-reveal>Total Leads</h4>
                <p data-reveal>1,248</p>
              </div>
              <div className="crm-preview-box" data-reveal>
                <h4 data-reveal>Active Deals</h4>
                <p data-reveal>86</p>
              </div>
              <div className="crm-preview-box" data-reveal>
                <h4 data-reveal>Follow-ups</h4>
                <p data-reveal>34</p>
              </div>
              <div className="crm-preview-box" data-reveal>
                <h4 data-reveal>Closed Sales</h4>
                <p data-reveal>219</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="crm-overview">
        <div className="crm-container">
          <div className="crm-section-heading">
            <span data-reveal>Why CRM Matters</span>
            <h2 data-reveal>Built to support growth, organization, and better customer experiences.</h2>
            <p data-reveal>
              A strong CRM helps you stay on top of leads, customer
              communication, and sales activity while giving your team the
              structure they need to work efficiently.
            </p>
          </div>
        </div>
      </div>

      <div className="crm-features-section" id="crm-features">
        <div className="crm-container">
          <div className="crm-section-heading left">
            <span data-reveal>Core Features</span>
            <h2 data-reveal>Everything you need to run a more organized customer pipeline.</h2>
          </div>

          <div className="crm-features-grid">
            {crmFeatures.map((feature, index) => (
              <div className="crm-feature-card" data-reveal key={index}>
                <div className="crm-feature-number" data-reveal="left">
                  {String(index + 1).padStart(2, "0")}
                </div>
                <h3 data-reveal>{feature.title}</h3>
                <p data-reveal>{feature.text}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="crm-process-section">
        <div className="crm-container crm-process-grid">
          <div className="crm-process-content">
            <span data-reveal>How It Works</span>
            <h2 data-reveal>A simple process that keeps your customer management clear.</h2>
            <p data-reveal>
              From lead capture to conversion, the system helps your team stay
              consistent, responsive, and focused on what matters most.
            </p>
          </div>

          <div className="crm-process-list">
            {crmSteps.map((step, index) => (
              <div className="crm-step-item" data-reveal key={index}>
                <div className="crm-step-count" data-reveal>{index + 1}</div>
                <p data-reveal>{step}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="crm-cta-section">
        <div className="crm-container crm-cta-box">
          <div>
            <span data-reveal>Let’s Build Your CRM</span>
            <h2 data-reveal>Ready to streamline your customer and sales workflow?</h2>
            <p data-reveal>
              Let’s create a CRM solution that fits your business process and
              helps your team work smarter.
            </p>
          </div>
         <div className="crm-primary-btn-wrapper">
          <button className="crm-primary-btn" data-reveal  onClick={handleContact}>
            Talk to Us
          </button>
         </div>
          
        </div>
      </div>
    </section>

    <Footer/>
    </div>
    </>
    
  );
};

export default Crm;